import React from "react";
import { NumberInput } from "react-admin";

import { UserRole } from "../../entities";
import { Currencies } from "../../entities/Currencies";
import { getKeyFromEnumByValue } from "../_helpers/mappers";
import { EditableGridCellField } from "./EditableGridCellField";

export const currencyLocales = "en-US";
// export const currencyOptions = { style: 'currency', currency: 'Nkr', maximumSignificantDigits: 3 };
export const currencyOptions = { maximumFractionDigits: 5 };

export const toPrice = (value, mainCurrency, hideCurrencyPrefix = false) => {
	if (value === null || value === undefined) {
		return value;
	}

	const formatted = value.toLocaleString(currencyLocales, currencyOptions);
	if (hideCurrencyPrefix) {
		return formatted;
	}
	const currency = getKeyFromEnumByValue(Currencies, mainCurrency);
	return `${currency} ` + formatted;
};

export const toPercent = (value) => {
	if (value === null || value === undefined) {
		return value;
	}
	return `% ` + (value * 100).toLocaleString(currencyLocales, currencyOptions);
};

export const PriceField = ({ asPercent, ...props }) => {
	if (props.record[props.source] === null || props.record[props.source] === undefined) {
		return null;
	}

	const value = props.record[props.source];

	if (asPercent) {
		return <span>{toPercent(value)}</span>;
	}

	return <span>{toPrice(value, props.mainCurrency, props.hideCurrencyPrefix)}</span>;
};

export const PriceEditableField = (props) => {
	const formatPriceField = (value) => toPrice(value, props.mainCurrency, props.hideCurrencyPrefix);

	const openPopupExtraCondition =
		props.permissions &&
		(props.permissions.role === UserRole.customer_manager ||
			props.permissions.role === UserRole.customer_employee);

	return (
		<EditableGridCellField
			{...props}
			formatField={formatPriceField}
			openPopupExtraCondition={openPopupExtraCondition}
			EditInputComponent={NumberInput}
		/>
	);
};

PriceField.defaultProps = {
	addLabel: true,
};

export const AccountancyNumberEditableField = (props) => {
	return <EditableGridCellField {...props} EditInputComponent={NumberInput} />;
};

AccountancyNumberEditableField.defaultProps = {
	addLabel: true,
};
